<template>
  <div>
    <vx-card>
      <b-row>
        <b-col cols="3" md="auto">
          <vs-button @click="getUretimList()" type="gradient" :id="[`loading-material`]" style=" border-radius: 5px"
            class="vs-con-loading__container">Listele</vs-button>
        </b-col>
        <b-col cols="3" md="auto">
          <vs-button style="border-radius: 5px" @click="yeniKayit()" type="gradient" color="danger">Yeni Kayıt</vs-button>
        </b-col>
      </b-row>
    </vx-card>
    <vx-card>
      <ag-grid-vue style="width: 100%;  margin-top: 25px; height: 500px" class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefsUretim" :rowData="rowdataUretim" :animateRows="true"
        :localeText="localeText" :suppressCopyRowsToClipboard="true" :masterDetail="true"
        :detailCellRendererParams="detailCellRendererParams" @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection" :enableCellChangeFlash="true">
      </ag-grid-vue>
    </vx-card>

    <vs-prompt title="Uyarı" acceptText="Onayla" cancelText="Vazgeç" @accept="uretimKaydet(0, 'DEL')"
      :active.sync="activePrompt" style="min-width: 1000px">
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col>
              <h6>Silme işlemini onaylıyor musunuz?</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
    <vs-popup classContent="popup-example" title="Üretim İşlemi" :active.sync="popupActive2" fullscreen>
      <vx-card>
        <b-row>
          <b-col>
            <b-row>
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px"> Stok Adı </span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 28px;" variant="warning">
                    <span style="font-size: 13px"> Miktar </span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px">Depo</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px">Lot No</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item class="d-flex" style="height: 32px;padding: 0px !important;">
                    <vue-autosuggest v-model="STOCK" style="width: 100%" :suggestions="filteredOptions2"
                      :get-suggestion-value="getSuggestionValue2" :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control'
                      }" @input="getStokList" @change="changedVal">
                      <template slot-scope="{ suggestion }">
                        <div class="d-flex align-items-center my-suggestion-item ">
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNAME.trim() }}/
                              {{ suggestion.item.STOCKNO.trim() }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 28px;padding: 0px !important;">
                    <b-form-input size="sm" v-model="miktarDeger" @keyup.enter="setSonucData" id="smallInput"
                      placeholder="Miktar" />
                  </b-list-group-item>
                  <b-list-group-item style="height: 32px; padding: 0px !important;">
                    <v-select v-model="DEPOID" :options="ANADEPOOPTION" label="DESCRIPTION" autocomplete size="small">
                    </v-select>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 32px;padding: 0px !important;">
                    <b-form-input size="sm" v-model="lotDeger" id="smallInput" placeholder="Lot No" />
                  </b-list-group-item>
                </b-list-group>
              </b-col> </b-row></b-col>

          <b-col>
            <b-row>
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px">
                      Grup Kodu
                    </span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px"> Özel Kod</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px"> Özel Kod 2</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 32px;" variant="warning">
                    <span style="font-size: 13px"> Durum </span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item style="height: 32px; padding: 0px !important;">
                    <v-select v-model="GROUPCODE" :options="GROUPCODEOPTION" label="DESCRIPTION" autocomplete
                      size="small">
                    </v-select>
                  </b-list-group-item>
                  <b-list-group-item style="height: 33px; padding: 0px !important;">
                    <v-select v-model="SPECCODE1" :options="SPECCODE1OPTION" label="DESCRIPTION" autocomplete
                      size="small">
                    </v-select>
                  </b-list-group-item>

                  
                  <b-list-group-item style="height: 30px; padding: 0px !important;">
                    <v-select v-model="SPECCODE2" :options="SPECCODE2OPTION" label="DESCRIPTION" autocomplete
                      size="small">
                    </v-select>
                  </b-list-group-item>

                  <b-list-group-item style="height: 37px; padding: 0px !important;">
                    <v-select v-model="STATUS" :options="STATUSOPTION" label="name" autocomplete size="small">
                    </v-select>
                  </b-list-group-item>
                </b-list-group>
              </b-col> </b-row></b-col>
          <b-col>
            <b-row>
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item class="d-flex" style="height: 30px;" variant="warning">
                    <span style="font-size: 13px">
                      Fiyat
                    </span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 30px;" variant="warning">
                    <span style="font-size: 13px"> Açıklama</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item class="d-flex" style="height: 28px;padding: 0px !important;">
                    <b-form-input v-if="yetkiTipi == 'Admin'" size="sm" v-model="PRICE" id="smallInput"
                      placeholder="Fiyat" />
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 70px;padding: 0px !important;">
                    <vs-textarea height="70px" style="font-size: 13px !important" v-model="DESCRIPTION" />
                  </b-list-group-item>
                </b-list-group>
              </b-col> </b-row></b-col>
        </b-row>
      </vx-card>
      <vx-card>
        <b-row style="margin-bottom: 25px !important">
          <b-col cols="8"><!--
            <div>
              <button v-on:click="onBtStopEditing()">stop ()</button>
              <button v-on:click="onBtNextCell()">next ()</button>
              <button v-on:click="onBtPreviousCell()">previous ()</button>
            </div>-->
            <b-button v-if="onayButonKontrol != true" style="background-color: #FF9F43; border-color:#FF9F43;"
              v-on:click="newRowRecete()">
              <Icon style="margin-right: 5px" icon="material-symbols:order-approve" width="20" height="20"
                v-b-tooltip.hover.bottom="'Ekle'" />Ekle
            </b-button>

            <ag-grid-vue style="width: 100%;  margin-top: 25px;  height: 250px;" class="ag-theme-alpine"
              :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowdata" :animateRows="true"
              :localeText="localeText" :suppressCopyRowsToClipboard="true" @grid-ready="onGridReady"
              @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelectionSingle"
              @selection-changed="onSelectionChanged" :enableCellChangeFlash="true" :singleClickEdit="true"
              @cell-clicked="onCellClicked" @row-value-changed="onRowValueChanged"
              @row-editing-started="onRowEditingStarted" @row-editing-stopped="onRowEditingStopped"
              @cell-editing-started="onCellEditingStarted" @cell-editing-stopped="onCellEditingStopped">
            </ag-grid-vue>
          </b-col>
          <b-col>
            <div class="demo-inline-spacing" style="margin-top: 25px; ">
              <b-col cols="12" v-if="updateValidate == true && lotDurumKontrol == true" style="margin-bottom: 8px">
                <b-form-input v-model="okutulanBarkod" style="font-size: inherit" ref="barkodM" type="text"
                  placeholder="Lot Kodu" @keyup.enter="okutulanOnayla" />
              </b-col>
              <p style="display: none;">{{ secilenLotNo }}</p>

              <b-form ref="form" @submit.prevent="repeateAgain">
                <b-row>
                  <b-col cols="12">
                    <b-row style="padding: 0">
                      <b-col style="padding: 0">
                        <b-button class="bg-primary" size="sm" v-on:click="repeateAgain()">
                          <Icon color="white" icon="material-symbols:add" width="20" height="20" />Ekle
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="5">
                        <p style="text-align: center">Lot Kodu</p>
                      </b-col>
                      <b-col cols="4">
                        <p style="text-align: center">Miktar</p>
                      </b-col>
                      <b-col cols="2"> </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12">
                    <div :class="scrollview" style="padding-right: 10px; margin-bottom:50px">
                      <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
                        <!-- Item Name -->
                        <b-col cols="5" style="padding-right: 0">
                          <b-form-group label-for="cost">
                            <b-form-input v-model="item.lotKodu" style="font-size: inherit" ref="barkodK" type="text"
                              placeholder="Kod" :disabled="item.disabled" />
                          </b-form-group>
                        </b-col>
                        <b-col cols="4" style="padding-right: 0">
                          <b-form-group label-for="cost">
                            <b-form-input v-model="item.lotMiktar" style="font-size: inherit" id="cost" type="text"
                              placeholder="Miktar" />
                          </b-form-group>
                        </b-col>

                        <!-- Quantity onayKontrol-->
                        <b-col style="padding-right: 0" cols="2" class="mb-50" v-if="item.onayKontrol == true">
                          <Icon icon="material-symbols:check-circle" color="#28c76f" width="25" height="25" />
                        </b-col>
                        <b-col style="padding-right: 0" cols="2" class="mb-50" v-else-if="item.onayKontrol == false">
                          <b-button variant="outline-light" size="sm" v-on:click="addTanim(index, '', 'uptonay')">
                            <Icon color="#28c76f" icon="material-symbols:edit" width="20" height="20" />
                          </b-button>
                        </b-col>
                        <b-col style="padding-right: 0" cols="2" class="mb-50" v-else>
                          <b-row>
                            <b-col style="padding-right: 0" cols="6" class="mb-50">
                              <b-row style="padding: 0">
                                <b-col style="padding: 0">
                                  <b-button :disabled="item.disabled" variant="outline-light" size="sm"
                                    v-on:click="addTanim(index)">
                                    <Icon color="#28c76f" icon="ic:baseline-save-all" width="20" height="20" />
                                  </b-button>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col cols="6" class="mb-50">
                              <b-row style="padding: 0">
                                <b-col style="padding: 0">
                                  <b-button variant="outline-light" size="sm" v-on:click="removeTanim(index)">
                                    <Icon color="#EA5455" icon="ic:baseline-remove-circle" width="20" height="20" />
                                  </b-button>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                        <!-- Remove Button -->

                        <b-col cols="12" style="height: 5px"> </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <!-- Row Loop -->
              </b-form>
            </div>
          </b-col>
        </b-row>
        <div slot="footer" style="margin-top: 20px !important">
          <vs-row vs-justify="flex-end">
            <b-button v-if="onayButonKontrol == true" style="background-color: #FF9F43; border-color:#FF9F43;"
              v-on:click="uretimOnayla(0)">
              <Icon style="margin-right: 5px" icon="material-symbols:order-approve" width="20" height="20"
                v-b-tooltip.hover.bottom="'Onayla'" />Onayla
            </b-button>
            <!-- -->
            <b-button v-if="genelDurum != 3" style="background-color: #EA5455; border-color:#EA5455;"
              v-on:click="lotGuncelle()">
              <Icon style="margin-right: 5px" icon="material-symbols:propane-tank" width="20" height="20"
                v-b-tooltip.hover.bottom="'Lot Güncelle'" />Lot Güncelle
            </b-button>
            <b-button style="background-color: #7367F0; border-color:#7367F0;" v-on:click="uretimYazdir(0)">
              <Icon style="margin-right: 5px" icon="material-symbols:print" width="20" height="20"
                v-b-tooltip.hover.bottom="'Kampanya oluştur'" />Yazdır
            </b-button><!--
            <b-button
              v-if="updateValidate == true"
              style="background-color: #28C76F; border-color:#28C76F;"
              v-on:click="lotKontrol(0, 'UPDATE')"
              ><Icon
                style="margin-right: 5px"
                icon="mdi:content-save-check-outline"
                width="20"
                height="20"
                v-b-tooltip.hover.bottom="'Güncelle'"
              />Güncelle</b-button
            >-->

            <b-button v-if="updateValidate == false" style="background-color: #28C76F; border-color:#28C76F;"
              v-on:click="lotKontrol(0)">
              <Icon style="margin-right: 5px" icon="mdi:content-save-check-outline" width="20" height="20"
                v-b-tooltip.hover.bottom="'Kampanya oluştur'" />Kaydet
            </b-button>
          </vs-row>
        </div>
      </vx-card>
      <b-modal ref="modal-yeniPro" id="modal-primary" modal-class="modal-primary" centered title="Lot Kaydı" size="xl"
        no-close-on-esc no-close-on-backdrop hide-header-close>
        <vx-card>
          <b-row align-h="start">
            <b-col cols="12" md="auto">
              <h5><span class="text-danger">Stok No: </span>{{ STOCKNO }}</h5>
            </b-col>
            <b-col cols="12" md="auto">
              <h5>
                <span class="text-danger">Stok Adı: </span>{{ STOCKNAME }}
              </h5>
            </b-col>
          </b-row>
        </vx-card>
        <vx-card>
          <ag-grid-vue style="width: 100%;  margin-top: 25px; height: 500px" class="ag-theme-alpine"
            :defaultColDef="defaultColDef" :columnDefs="columnDefsLot" :rowData="rowdataLot" :animateRows="true"
            :localeText="localeText" :suppressCopyRowsToClipboard="true" :masterDetail="true"
            :detailCellRendererParams="detailCellRendererParamsLot" @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection" :enableCellChangeFlash="true">
          </ag-grid-vue>
        </vx-card>
      </b-modal>

      <b-modal ref="modal-lotList" id="modal-primary" modal-class="modal-primary" centered title="Lot Listesi" size="lg"
        hide-footer>
        <vx-card>
          <b-row align-h="start">
            <b-col cols="12" md="auto">
              <h6>
                <span class="text-danger">Stok No: </span>{{ lotsStokStokNo }}
              </h6>
            </b-col>
            <b-col cols="12" md="auto">
              <h6>
                <span class="text-danger">Stok Adı: </span>{{ lotsStokStokName }}
              </h6>
            </b-col>
          </b-row>
        </vx-card>
        <vx-card>
          <vs-table pagination max-items="50" stripe :data="rowdataLotList" @dblSelection="handleSelected">
            <template slot="thead">
              <vs-th sort-key="orderNumber">Lot No</vs-th>
              <vs-th sort-key="orderNumber">rezerved</vs-th>

              <vs-th sort-key="DEPOTNAME">Depo</vs-th>
              <vs-th sort-key="invoiceFirstName">Miktar</vs-th>
              <vs-th sort-key="rezerveQt">Rezerve Miktar</vs-th>
              <vs-th sort-key="rezerveQt">Serbest Kalan</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].LOTNO">
                  {{ data[indextr].LOTNO }}
                </vs-td>
                <vs-td :data="data[indextr].REZERVED">
                  {{ data[indextr].REZERVED }}
                </vs-td>
                <vs-td :data="data[indextr].DEPOTNAME">
                  {{ data[indextr].DEPOTNAME }}
                </vs-td>
                <vs-td :data="data[indextr].QREM">
                  {{ data[indextr].QREM.toFixed(4) }}
                </vs-td>
                <vs-td :data="data[indextr].rezerveQt">
                  {{ data[indextr].rezerveQt }}
                </vs-td>

                <vs-td :data="data[indextr].rezerveQt" v-if="isNaN(
                  parseFloat(data[indextr].QREM) -
                  parseFloat(data[indextr].rezerveQt)
                ) == false
                ">
                  {{
                    (
                      parseFloat(data[indextr].QREM) -
                      parseFloat(data[indextr].rezerveQt)
                    ).toFixed(4)
                  }}
                </vs-td>
                <vs-td :data="data[indextr].rezerveQt" v-else> </vs-td>
              </vs-tr>

              <vs-tr> </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </b-modal>
    </vs-popup>
    <UretimReceteCikti ref="uretimReceteCikti" />
  </div>
</template>

<script>
import MpUretimIslemiReceteSil from "../components/uzum-components/mpstokyonetimi-components/MpUretimIslemiReceteSil.vue";
import MpUretimIslemiLotBilgiButton from "../components/uzum-components/mpstokyonetimi-components/MpUretimIslemiLotBilgiButton.vue";
import LotDurumCellRenderer from "./CellRenderers/LotDurumCellRenderer.vue";
import StockAutosuggest from "../components/uzum-components/mpstokyonetimi-components/StockAutosuggest.vue";
import moment from "moment";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import DurumGorunumCellRenderer from "./CellRenderers/DurumGorunumCellRenderer.vue";
import UretimReceteCikti from "../components/uzum-components/mpstokyonetimi-components/UretimReceteCikti.vue";
import UretimStokBirimCellRenderer from "./CellRenderers/UretimStokBirimCellRenderer.vue";
import UretimStokDepoCellRenderer from "./CellRenderers/UretimStokDepoCellRenderer";
import UretimStokGrupKodCellRenderer from "./CellRenderers/UretimStokGrupKodCellRenderer";
import UretimStokOzelKod1CellRenderer from "./CellRenderers/UretimStokOzelKod1CellRenderer.vue";
import UretimStokOzelKod2CellRenderer from "./CellRenderers/UretimStokOzelKod2CellRenderer.vue";
import UretimDurumGorunumCellRenderer from "./CellRenderers/UretimDurumGorunumCellRenderer.vue";
import MpUretimIslemiButton from "../components/uzum-components/mpstokyonetimi-components/MpUretimIslemiButton.vue";
export default {
  data() {
    return {
      secilendegeritemNo: "",
      genelDurum: 0,
      yetkiTipi: "",
      secilenLotNo: "",
      uretimPriceTotal: 0.0,
      uretimTotal: 0.0,
      globstokId: "",
      UretimDurumu: "",
      lotDurumKontrol: false,
      secilenStokInfo: [],
      columnDefsLotList: null,
      rowdataLotList: null,
      lotsStokStokName: "",
      lotsStokStokNo: "",

      onayButonKontrol: false,
      okutulanBarkod: "",
      activeLoading: false,
      types: ["material"],
      secilenStokIndex: "",
      secilenStok: [],
      kalanMikTanim: 0,
      items: [
        {
          id: 0,
          lotKodu: "",
          lotMiktar: "",
          kod: "",
          disabled: false,
          ROOT: "",
          ROOTFIELD: "",
          STOCKLOTSID: "",
          COMPANYID: "",
          STOCKID: ""
        }
      ],
      scrollview: "",
      columnDefsLot: null,
      rowdataLot: null,
      detailCellRendererParamsLot: null,

      popupActive2: false,
      popupActive3: false,
      lotDeger: "",
      editType: null,
      STATUSOPTION: [
        { name: "Aktif", val: 2 },
        { name: "Pasif", val: 3 }
      ],

      GROUPCODEOPTION: [],
      SPECCODE1OPTION: [],
      SPECCODE2OPTION: [],
      activePrompt: false,
      updateValidate: false,
      detailCellRendererParams: null,
      ANADEPO: "",
      ANADEPOOPTION: [],
      ANAUNITOPTION: [],
      arananDeger: "",
      miktarDeger: "",
      rowSelection: null,
      rowSelectionSingle: null,
      rowdata: [],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null,
      columnDefsUretim: null,
      rowdataUretim: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      stokListesi: [],
      filteredOptions2: [],
      STOCK: "",
      stokArananInput: "",

      COMPANYID: "",
      STOCKID: "",
      STOCKNO: "",
      STOCKNAME: "",
      STOCKNAME2: "",
      STATUS: { name: "Aktif", val: 1 },
      DEPOID: "",
      UNIT: "",
      VAT: "",
      GROUPCODE: "",
      SPECCODE1: "",
      SPECCODE2: "",
      SPECCODE3: "",
      SPECCODE4: "",
      SPECCODE5: "",
      SEASON: "",
      BRAND: "",
      MODEL: "",
      CATAGORY1: "",
      CATAGORY2: "",
      CATAGORY3: "",
      CATAGORY4: "",
      CATAGORY5: "",
      CURRCODE: "",
      PRICE: "",
      PRICE2: "",
      PRICE3: "",
      PRICE4: "",
      PRICE5: "",
      BARCODE: "",
      BARCODE1: "",
      BARCODE2: "",
      BARCODE3: "",
      BARCODE4: "",
      CUSTOMERSTOCKNO: "",
      SUPPLIERSTOCKNO: "",
      WEBSTOCK: "",
      ORIGIN: "",
      BARKOD: "",
      DESCRIPTION: "",
      NOTES: "",
      INSERTDATE: "",
      INSERTUSER: "",
      EDITDATE: "",
      EDITUSER: "",
      nextTodoId: 1,
      RECEIPTNO: "",
      RECEIPTID: "",

      UNITCODE: "",
      GROUPCODECODE: "",
      SPECCODE1CODE: "",
      SPECCODE2CODE: "",
      SPECCODE3CODE: "",
      SPECCODE4CODE: "",
      SPECCODE5CODE: "",
      CURRCODECODE: "",
      CATAGORY1CODE: "",
      CATAGORY2CODE: "",
      CATAGORY3CODE: "",
      CATAGORY4CODE: "",
      CATAGORY5CODE: "",

      tableheight: "",
      maxVal: "",
      globIndex: "",
      isfollowLots: false
    };
  },
  components: {
    MpUretimIslemiReceteSil,
    StockAutosuggest,
    UretimDurumGorunumCellRenderer,
    DurumGorunumCellRenderer,
    UretimReceteCikti,
    MpUretimIslemiLotBilgiButton,
    LotDurumCellRenderer,
    MpUretimIslemiButton,
    Icon,
    "v-select": vSelect,
    AgGridVue,
    UretimStokBirimCellRenderer,
    UretimStokGrupKodCellRenderer,
    UretimStokDepoCellRenderer,
    UretimStokOzelKod1CellRenderer,
    UretimStokOzelKod2CellRenderer
  },
  created() {
    this.rowSelectionSingle = "single";
    this.scrollview = "scroll-hand";
    this.editType = "fullRow";
    this.getStokList();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.getTanimList("DEPOTID");
    this.getTanimList("UNIT");
    this.getTanimList("GROUPCODE");
    this.getTanimList("SPECCODE1");
    this.getTanimList("SPECCODE2");
    this.getUretimList("kontrol");
    this.yetkiTipi = Store.state.genelData.yetkiTipi;
  },
  methods: {
    handleSelected(tr) {

      this.items[this.items.length - 1] = {
        id: 0,
        lotKodu: tr.LOTNO,
        lotMiktar: 0,
        kod: "",
        disabled: false,
        ROOT: "",
        ROOTFIELD: "",
        STOCKLOTSID: "",
        COMPANYID: "",
        STOCKID: "",
        DEPOTID: tr.DEPOTID
      };
      this.secilenLotNo = tr;
      this.$refs["modal-lotList"].hide();
    },
    lotGuncelle(index) {
      this.lotsKayit(0, "EKLE", this.RECEIPTID, "UPTONAY");
    },
    setStokValue(index, item, stokid, group) {
      try {

        const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
        rowNode.setDataValue("MIXSTOCKID", item.STOCKID);
        rowNode.setDataValue("MIXDEPOTID", item.DEPOIDCODE);
        rowNode.setDataValue("FOLLOWLOT", item.FOLLOWLOT);
        rowNode.setDataValue("MIXDEPOTIDDESC", item.DEPOTID);
        rowNode.setDataValue("MIXSTOCKUNIT", item.UNITCODE);
        rowNode.setDataValue("MIXSPECCODE1", item.SPECCODE1CODE);
        rowNode.setDataValue("MIXSPECCODE2", item.SPECCODE2CODE);
        rowNode.setDataValue("MIXGROUPCODE", item.GROUPCODECODE);
        rowNode.setDataValue("MIXPRICE", item.MIXSTOCKPRICE);
        rowNode.setDataValue("MIXQUANTITY", 1.0);

        rowNode.setDataValue("MIXSTOCKNAME", item.STOCKNAME);

        this.rowdata[index].MIXQUANTITY2 = 1.0;
        rowNode.setDataValue("MIXSTOCKNO", item.COMPANYID);

      } catch (error) {
        console.log(error);
      }

    },
    removeRowRecete(item) {
      try {
        var vs = this.$vs;
        const selectedData = this.gridApi.getSelectedRows();
        const res = this.gridApi.applyTransaction({ remove: selectedData });

        this.rowdata = [];
        this.gridApi.forEachNode((rowNode, index) => {
          this.rowdata.push(rowNode.data);
        });
      } catch (err) {
        console.log(err)
      }

    },
    newRowRecete() {
      const row = [
        {
          MIXSTOCKNO: "",
          MIXSTOCKNAME: "",
          MIXQUANTITY: "",
          MIXQUANTITY2: "",
          MIXQUANTITYREDUCED: "",
          MIXPRICE: "",
          MIXGROUPCODE: "",
          MIXSPECCODE1: "",
          MIXSPECCODE2: "",
          MIXSTOCKUNIT: "",
          MIXDEPOTIDDESC: "",
          DESCRIPTION: "",
          FOLLOWLOT: "",
          MIXDEPOTID: ""
        }
      ];

      let addIndex = 0;
      const res = this.gridApi.applyTransaction({
        add: row,
        addIndex: addIndex
      });
      this.rowdata = [];
      this.gridApi.forEachNode((rowNode, index) => {
        this.rowdata.push(rowNode.data);
      });
    },
    uretimYazdir() {
      this.$refs.uretimReceteCikti.uretimDetayCek(
        this.items,
        this.secilenStokInfo
      );
    },
    stokLotsTransAdd(index) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      if (index == vm.items.length) {
        // vm.lotsKayit(0, "UPT", vm.RECEIPTID);

        vs.notify({
          title: "Kayıt",
          text: "Kayıt işlemleri başarılı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center"
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          ROOTRECEIPTITEMNO: index + 1,
          ISLEM: "EKLE",
          ROOTRECEIPTNO: vm.RECEIPTNO,
          ROOT: "306",
          ROOTID: vm.RECEIPTID,
          INSERTUSERID: Store.state.UserId,
          EDITUSERID: Store.state.UserId
        };
        soap.createClient(url, function (err, client) {
          client.STOCKLOTSTRANSADD(args, function (err, result) {
            if (result.STOCKLOTSTRANSADDResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKLOTSTRANSADDResult);
            try {
              if (vm.veriler.response == "Ok") {
                //   vm.stokLotsTransAdd(index + 1);
              } else {
                vs.notify({
                  title: "Lot trans",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Lot trans",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    addLotsCard() {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");

      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.STOCKID,
        LOTNO: vm.RECEIPTNO,
        INSERTUSERID: Store.state.MusteriId,
        EDITUSERID: Store.state.MusteriId,
        ROOT: "306",
        ROOTID: vm.RECEIPTID,
        DEPOTID: vm.DEPOID.CODE,
        QUANTITY: vm.miktarDeger
      };
      soap.createClient(url, function (err, client) {
        client.STOCKLOTSCARDADD(args, function (err, result) {
          if (result.STOCKLOTSCARDADDResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLOTSCARDADDResult);
          try {
            if (vm.veriler.response == "Ok") {
            } else {
              vs.notify({
                title: "Lot Kart Kaydı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) { }
        });
      });
    },
    uretimOnayla(index) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (index == vm.items.length) {

        vm.uretimOnayla(-2);
      } else if (index == -2) {
        const args = {
          token: Store.state.tokenId,
          STOCKID: vm.STOCKID,
          ITEMNO: "1",
          DESCRIPTION: vm.RECEIPTNO + " nolu imalat fişi.",
          EMPLOYEEID: Store.state.UserId,
          ROOTRECEIPTITEMNO: 1,
          QENTRY: vm.miktarDeger,
          QEXIT: 0,
          ISLEM: "EKLE",
          ROOTRECEIPTNO: vm.RECEIPTNO,
          ROOT: "306",
          ROOTID: vm.RECEIPTID,
          STOCKLOTSID: 0,
          DEPOTID: vm.DEPOID.CODE,
          PRICE: vm.PRICE,
          INSERTUSERID: Store.state.UserId,
          EDITUSERID: Store.state.UserId,
          UNITIDTRANS: vm.UNIT
        };

        soap.createClient(url, function (err, client) {
          client.STOCKTRANSADD(args, function (err, result) {
            if (result.STOCKTRANSADDResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKTRANSADDResult);
            try {
              if (vm.veriler.response == "Ok") {
                // vm.stokLotsTransAdd(0);



                vm.lotsKayit(0, "UPT", vm.RECEIPTID);
              } else {
                vs.notify({
                  title: "Stok trans kayıt",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Stok trans kayıt",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      } else {
        let miktarUyumKontrol = vm.rowdata.filter(post => {
          return post.STOCKID.toString() == vm.items[index].STOCKID;
        });
        console.log(vm.items[index])
        const args = {
          token: Store.state.tokenId,
          STOCKID: vm.items[index].STOCKID,
          ITEMNO: index + 1,
          DESCRIPTION: vm.RECEIPTNO + " nolu imalat fişinde kullanıldı",
          EMPLOYEEID: Store.state.UserId,
          ROOTRECEIPTITEMNO: vm.items[index].ITEMNO,
          QENTRY: 0,
          QEXIT: vm.items[index].lotMiktar,
          ISLEM: "EKLE",
          ROOTRECEIPTNO: vm.RECEIPTNO,
          ROOT: "306",
          ROOTID: vm.RECEIPTID,
          STOCKLOTSID: vm.items[index].STOCKLOTSID,
          DEPOTID: miktarUyumKontrol[0].MIXDEPOTID,
          PRICE: miktarUyumKontrol[0].MIXPRICE,
          INSERTUSERID: Store.state.UserId,
          EDITUSERID: Store.state.UserId,
          UNITIDTRANS: vm.items[index].UNITID
        };

        soap.createClient(url, function (err, client) {
          client.STOCKTRANSADD(args, function (err, result) {
            if (result.STOCKTRANSADDResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKTRANSADDResult);
            try {
              if (vm.veriler.response == "Ok") {
                vm.uretimOnayla(index + 1);
              } else {
                vs.notify({
                  title: "Stok trans kayıt",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Stok trans kayıt",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    okutulanOnayla(index) {
      let miktarUyumKontrol = this.items.filter(post => {
        return (
          post.lotKodu.toString().toUpperCase() ==
          this.okutulanBarkod.toString().toUpperCase()
        );
      });
      if (miktarUyumKontrol.length == 0) {
        this.$vs.notify({
          text: "Okutulan lot un kayıtlı olduğundan emin olun",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        let mikk = this.items
          .map(e => e.lotKodu)
          .indexOf(miktarUyumKontrol[0].lotKodu);

        this.items[mikk].onayKontrol = true;
      }
      let onayKontrolVal = [];
      this.items.forEach((val, index) => {
        if (val.onayKontrol == false) onayKontrolVal.push("false");
        else onayKontrolVal.push("true");
      });
      if (onayKontrolVal.toString().includes("false") == true) {
        this.onayButonKontrol = false;
      } else {
        this.onayButonKontrol = true;
      }
      //  this.items[index].onayKontrol = true;
      this.okutulanBarkod = "";
    },
    listele() { },
    repeateAgain() {
      this.items.push({
        id: 1,
        disabled: false
      });
      this.$nextTick(() => this.$refs.barkodK[0].focus());
    },
    removeTanim(index) {
      this.items.splice(index, 1);

      const rowNode = this.gridApi.getDisplayedRowAtIndex(
        this.secilenStokIndex
      );
      let miktarUyumKontrol = this.items.filter(post => {
        return post.STOCKID == this.secilenStok[0].MIXSTOCKID;
      });
      let toplamLotMikk = 0.0;
      miktarUyumKontrol.forEach((val, index) => {
        toplamLotMikk += parseFloat(val.lotMiktar);
      });
      rowNode.setDataValue(
        "MIXQUANTITYREDUCED",
        parseFloat(this.secilenStok[0].MIXQUANTITY) - parseFloat(toplamLotMikk)
      );
    },
    onCellClicked(params) {
      this.secilenStokIndex = params.rowIndex;
    },
    onSelectionChanged(params) {
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenStok = selectedRows;
      console.log(this.secilenStok)
      console.log(this.rowdata)
      this.secilendegeritemNo = this.rowdata.map(e => e.MIXSTOCKID).indexOf(this.secilenStok[0].MIXSTOCKID);
      console.log(this.secilendegeritemNo)
    },
    addTanim(index, islem, iss) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      console.log(vm.secilenStok[0].ISMIX)
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      if (islem == "DEL") {
      } else {
        if (
          vm.items[index].lotKodu == "" ||
          typeof vm.items[index].lotKodu == "undefined"
        ) {
          vs.notify({
            title: "Lot Ekleme",
            text: "Kod alanı zorunludur",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        } else if (vm.secilenStok.length == 0) {
          vs.notify({
            title: "Lot Ekleme",
            text: "Stok seçimi yapmadınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        } else {
          let bulunan = [];
          let deger = 0;
          let filteredItem = vm.items.filter(post => {
            return (
              vm.items[index].lotKodu.toUpperCase() ==
              post.lotKodu.toUpperCase() &&
              post.STOCKID == vm.secilenStok[0].MIXSTOCKID &&
              post.disabled == true
            );
          });
          if (filteredItem.length > 0) {
            vs.notify({
              title: "Lot Ekleme",
              text: "Lot kodu daha önce kullanılmış",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center"
            });
          } else {
            let kontrolForLot = false;

            if (vm.secilenStok[0].FOLLOWLOT == true) {
              let miktarUyumKontrol = vm.items.filter(post => {
                return post.STOCKID == vm.secilenStok[0].MIXSTOCKID;
              });

              let toplamLotMikk = 0.0;
              miktarUyumKontrol.forEach((val, index) => {
                toplamLotMikk += parseFloat(val.lotMiktar);
              });

              if (vm.secilenStok[0].MIXQUANTITY == toplamLotMikk) {
                kontrolForLot = true;
              } else {
                kontrolForLot = false;
              }
            }
            if (
              kontrolForLot.toString().includes("true") == true &&
              vm.UretimDurumu != "UPDATE"
            ) {
              vs.notify({
                title: "Lot İşlemi",
                text: "Fazla lot girişi yaptınız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            } else {
              const args = {
                token: Store.state.tokenId,
                COMPANYID: state.MusteriId,
                STOCKID:
                  vm.UretimDurumu == "UPDATE"
                    ? vm.secilenStok[0].STOCKID
                    : vm.secilenStok[0].MIXSTOCKID,
                LOTNO: vm.items[index].lotKodu,
                ISLEM: islem,
                DEPOTID: vm.items[index].DEPOTID
              };
              soap.createClient(url, function (err, client) {
                client.STOCKLOTSLIST(args, function (err, result) {
                  if (result.STOCKLOTSLISTResult == "-1") {
                    Store.dispatch("logout");
                    //this.$store.dispatch('login', payload)
                  }
                  try {
                    vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
                    let lotListesi = JSON.parse(vm.veriler.jsonData);

                    if (vm.veriler.response == "Ok") {
                      if (lotListesi.length > 0) {
                        vs.notify({
                          title: "Lot Ekleme",
                          text: vm.veriler.message,
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "success",
                          position: "top-center"
                        });
                        let mikTanim = 0;
                        let rowData5 = [];
                        vm.gridApi.forEachNode(node =>
                          rowData5.push(node.data)
                        );
                        console.log(lotListesi[0].QREM - lotListesi[0].rezerveQt)
                        if (lotListesi[0].QREM - lotListesi[0].rezerveQt >= 0) {

                          if (
                            typeof vm.secilenStok[0].MIXQUANTITYREDUCED !=
                            "undefined" &&
                            vm.secilenStok[0].MIXQUANTITYREDUCED != ""
                          ) {
                            if (
                              typeof vm.items[index].lotMiktar != "undefined" &&
                              vm.items[index].lotMiktar != ""
                            ) {
                              if (
                                parseFloat(vm.items[index].lotMiktar) >
                                parseFloat(vm.secilenStok[0].MIXQUANTITYREDUCED)
                              ) {
                                vs.notify({
                                  title: "Lot Ekleme",
                                  text:
                                    "Satır miktarından fazla miktar ekleyemezsiniz",
                                  iconPack: "feather",
                                  icon: "icon-alert-circle",
                                  color: "warning",
                                  position: "top-center"
                                });
                              } else if (
                                parseFloat(vm.items[index].lotMiktar) >
                                parseFloat(lotListesi[0].QREM)
                              ) {
                                vs.notify({
                                  title: "Lot Ekleme",
                                  text:
                                    "Lot miktarından fazla miktar ekleyemezsiniz",
                                  iconPack: "feather",
                                  icon: "icon-alert-circle",
                                  color: "warning",
                                  position: "top-center"
                                });
                              } else {
                                const rowNode = vm.gridApi.getDisplayedRowAtIndex(
                                  vm.secilenStokIndex
                                );
                                rowNode.setDataValue(
                                  "MIXQUANTITYREDUCED",
                                  parseFloat(
                                    vm.secilenStok[0].MIXQUANTITYREDUCED
                                  ) - parseFloat(vm.items[index].lotMiktar)
                                );
                                mikTanim = vm.items[index].lotMiktar;
                                if (lotListesi[0].QREM - lotListesi[0].rezerveQt < mikTanim) {
                                  mikTanim = lotListesi[0].QREM - lotListesi[0].rezerveQt
                                }
                                vm.items[index].lotMiktar = parseFloat(
                                  mikTanim
                                ).toFixed(5);
                                vm.items[index].ISMIX = vm.secilenStok[0].ISMIX == true ? true : false;
                                vm.items[index].LOTPRICE = lotListesi[0].PRICE;
                                vm.items[index].disabled = true;
                                vm.items[index].CURRPRICE =
                                  lotListesi[0].CURRPRICE;
                                vm.items[index].CURRCODE = lotListesi[0].CURRCODE;
                                vm.items[index].ROOT = lotListesi[0].ROOT;
                                vm.items[index].DEPOTID = lotListesi[0].DEPOTID;
                                vm.items[index].UNITID = vm.secilenStok[0].UNITID;
                                vm.items[index].ITEMNO = vm.secilendegeritemNo;
                               // vm.rowdataLotList[index].REZERVED = true;
                                if (
                                  vm.UretimDurumu == "UPDATE" &&
                                  iss != "uptonay"
                                )
                                  vm.items[index].uptKontrol = true;
                                else vm.items[index].uptKontrol = false;
                                vm.items[index].STOCKLOTSID =
                                  lotListesi[0].STOCKLOTSID;
                                vm.items[index].STOCKID =
                                  vm.UretimDurumu == "UPDATE"
                                    ? vm.secilenStok[0].STOCKID
                                    : vm.secilenStok[0].MIXSTOCKID;
                                vm.items[index].STOCKNO =
                                  vm.UretimDurumu == "UPDATE"
                                    ? vm.secilenStok[0].STOCKNO
                                    : vm.secilenStok[0].MIXSTOCKNO;
                                vm.items.push({
                                  id: index + 1,
                                  disabled: false
                                });

                                vm.$nextTick(() =>
                                  vm.$refs.barkodK[index + 1].focus()
                                );
                              }
                            } else {
                              if (
                                parseFloat(vm.secilenStok[0].MIXQUANTITYREDUCED) >
                                parseFloat(lotListesi[0].QREM)
                              ) {
                                const rowNode = vm.gridApi.getDisplayedRowAtIndex(
                                  vm.secilenStokIndex
                                );
                                rowNode.setDataValue(
                                  "MIXQUANTITYREDUCED",
                                  parseFloat(
                                    vm.secilenStok[0].MIXQUANTITYREDUCED
                                  ) - parseFloat(lotListesi[0].QREM)
                                );
                                mikTanim = lotListesi[0].QREM;
                              } else {
                                mikTanim = vm.secilenStok[0].MIXQUANTITYREDUCED;
                              }
                              if (lotListesi[0].QREM - lotListesi[0].rezerveQt < mikTanim) {
                                mikTanim = lotListesi[0].QREM - lotListesi[0].rezerveQt
                              }
                              vm.items[index].lotMiktar = parseFloat(
                                mikTanim
                              ).toFixed(5);
                              vm.items[index].disabled = true;
                              vm.items[index].ISMIX = vm.secilenStok[0].ISMIX == true ? true : false;
                              vm.items[index].LOTPRICE = lotListesi[0].PRICE;
                              vm.items[index].CURRPRICE = lotListesi[0].CURRPRICE;
                              vm.items[index].CURRCODE = lotListesi[0].CURRCODE;
                              vm.items[index].ROOT = lotListesi[0].ROOT;
                              vm.items[index].DEPOTID = lotListesi[0].DEPOTID;
                              vm.items[index].UNITID = vm.secilenStok[0].UNITID;
                              vm.items[index].ITEMNO = vm.secilendegeritemNo;
                            //  vm.rowdataLotList[index].REZERVED = true;
                              if (vm.UretimDurumu == "UPDATE" && iss != "uptonay")
                                vm.items[index].uptKontrol = true;
                              else vm.items[index].uptKontrol = false;
                              vm.items[index].STOCKLOTSID =
                                lotListesi[0].STOCKLOTSID;

                              vm.items[index].STOCKID =
                                vm.UretimDurumu == "UPDATE"
                                  ? vm.secilenStok[0].STOCKID
                                  : vm.secilenStok[0].MIXSTOCKID;
                              vm.items[index].STOCKNO =
                                vm.UretimDurumu == "UPDATE"
                                  ? vm.secilenStok[0].STOCKNO
                                  : vm.secilenStok[0].MIXSTOCKNO;
                              vm.items.push({
                                id: index + 1,
                                disabled: false
                              });
                              vm.$nextTick(() =>
                                vm.$refs.barkodK[index + 1].focus()
                              );
                            }
                          } else {
                            if (
                              typeof vm.items[index].lotMiktar != "undefined" &&
                              vm.items[index].lotMiktar != "" &&
                              vm.items[index].lotMiktar != 0
                            ) {
                              if (
                                parseFloat(vm.items[index].lotMiktar) >
                                parseFloat(vm.secilenStok[0].MIXQUANTITY)
                              ) {
                                vs.notify({
                                  title: "Lot Ekleme",
                                  text:
                                    "Satır miktarından fazla miktar ekleyemezsiniz",
                                  iconPack: "feather",
                                  icon: "icon-alert-circle",
                                  color: "warning",
                                  position: "top-center"
                                });
                              } else if (
                                parseFloat(vm.items[index].lotMiktar) >
                                parseFloat(lotListesi[0].QREM)
                              ) {
                                vs.notify({
                                  title: "Lot Ekleme",
                                  text:
                                    "Lot miktarından fazla miktar ekleyemezsiniz",
                                  iconPack: "feather",
                                  icon: "icon-alert-circle",
                                  color: "warning",
                                  position: "top-center"
                                });
                              } else {
                                const rowNode = vm.gridApi.getDisplayedRowAtIndex(
                                  vm.secilenStokIndex
                                );
                                rowNode.setDataValue(
                                  "MIXQUANTITYREDUCED",
                                  vm.secilenStok[0].MIXQUANTITY -
                                  vm.items[index].lotMiktar
                                );
                                mikTanim = vm.items[index].lotMiktar;
                                if (lotListesi[0].QREM - lotListesi[0].rezerveQt < mikTanim) {
                                  mikTanim = lotListesi[0].QREM - lotListesi[0].rezerveQt
                                }
                                vm.items[index].LOTPRICE = lotListesi[0].PRICE;
                                vm.items[index].ISMIX = vm.secilenStok[0].ISMIX == true ? true : false;
                                vm.items[index].CURRPRICE =
                                  lotListesi[0].CURRPRICE;
                                vm.items[index].CURRCODE = lotListesi[0].CURRCODE;
                                vm.items[index].lotMiktar = parseFloat(
                                  mikTanim
                                ).toFixed(5);
                                vm.items[index].disabled = true;
                                vm.items[index].ROOT = lotListesi[0].ROOT;
                                vm.items[index].DEPOTID = lotListesi[0].DEPOTID;
                                vm.items[index].UNITID = vm.secilenStok[0].UNITID;
                                vm.items[index].ITEMNO = vm.secilendegeritemNo;
                               // vm.rowdataLotList[index].REZERVED = true;
                                if (
                                  vm.UretimDurumu == "UPDATE" &&
                                  iss != "uptonay"
                                )
                                  vm.items[index].uptKontrol = true;
                                else vm.items[index].uptKontrol = false;
                                vm.items[index].STOCKLOTSID =
                                  lotListesi[0].STOCKLOTSID;
                                vm.items[index].STOCKID =
                                  vm.UretimDurumu == "UPDATE"
                                    ? vm.secilenStok[0].STOCKID
                                    : vm.secilenStok[0].MIXSTOCKID;
                                vm.items[index].STOCKNO =
                                  vm.UretimDurumu == "UPDATE"
                                    ? vm.secilenStok[0].STOCKNO
                                    : vm.secilenStok[0].MIXSTOCKNO;
                                vm.items.push({
                                  id: index + 1,
                                  disabled: false
                                });
                                vm.$nextTick(() =>
                                  vm.$refs.barkodK[index + 1].focus()
                                );
                              }
                            } else {
                              if (
                                parseFloat(vm.secilenStok[0].MIXQUANTITY) >
                                parseFloat(lotListesi[0].QREM)
                              ) {
                                const rowNode = vm.gridApi.getDisplayedRowAtIndex(
                                  vm.secilenStokIndex
                                );
                                rowNode.setDataValue(
                                  "MIXQUANTITYREDUCED",
                                  parseFloat(vm.secilenStok[0].MIXQUANTITY) -
                                  parseFloat(lotListesi[0].QREM)
                                );
                                mikTanim = lotListesi[0].QREM;
                              } else {
                                mikTanim = vm.secilenStok[0].MIXQUANTITY;
                              }
                              if (lotListesi[0].QREM - lotListesi[0].rezerveQt < mikTanim) {
                                mikTanim = lotListesi[0].QREM - lotListesi[0].rezerveQt
                              }
                              vm.items[index].lotMiktar = parseFloat(
                                mikTanim
                              ).toFixed(5);
                              vm.items[index].disabled = true;
                              vm.items[index].ISMIX = vm.secilenStok[0].ISMIX == true ? true : false;
                              vm.items[index].ROOT = lotListesi[0].ROOT;
                              vm.items[index].LOTPRICE = lotListesi[0].PRICE;
                              vm.items[index].CURRPRICE = lotListesi[0].CURRPRICE;
                              vm.items[index].CURRCODE = lotListesi[0].CURRCODE;
                              vm.items[index].DEPOTID = lotListesi[0].DEPOTID;
                              vm.items[index].UNITID = vm.secilenStok[0].UNITID;
                              vm.items[index].ITEMNO = vm.secilendegeritemNo;
                           //   vm.rowdataLotList[index].REZERVED = true;
                              if (vm.UretimDurumu == "UPDATE" && iss != "uptonay")
                                vm.items[index].uptKontrol = true;
                              else vm.items[index].uptKontrol = false;
                              vm.items[index].STOCKLOTSID =
                                lotListesi[0].STOCKLOTSID;
                              vm.items[index].STOCKID =
                                vm.UretimDurumu == "UPDATE"
                                  ? vm.secilenStok[0].STOCKID
                                  : vm.secilenStok[0].MIXSTOCKID;
                              vm.items[index].STOCKNO =
                                vm.UretimDurumu == "UPDATE"
                                  ? vm.secilenStok[0].STOCKNO
                                  : vm.secilenStok[0].MIXSTOCKNO;
                              vm.items.push({
                                id: index + 1,
                                disabled: false
                              });
                              vm.$nextTick(() =>
                                vm.$refs.barkodK[index + 1].focus()
                              );
                            }
                          }
                        } else {
                          vs.notify({
                            title: "Lot Ekleme",
                            text:
                              "Rezerve miktarı aşmayın",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-center"
                          });
                        }
console.log( vm.rowdataLotList)
                      } else {
                        vs.notify({
                          title: "Lot Ekleme",
                          text:
                            "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "danger",
                          position: "top-center"
                        });
                      }
                    } else
                      vs.notify({
                        title: "Lot Ekleme",
                        text:
                          "Lot kaydının sistemden kayıtlı olduğundan emin olun",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                        position: "top-center"
                      });
                  } catch (error) {
                    console.log(error);
                    vs.notify({
                      title: "Lot Ekleme",
                      text: "Lot Kaydı sırasında hata oluştu",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-center"
                    });
                  }
                });
              });
            }
          }
        }
      }
    },
    onRowEditingStarted(event) { },
    onRowEditingStopped(event) { },
    onCellEditingStarted(event) { },
    onCellEditingStopped(event) { },
    onBtStopEditing() {
      this.gridApi.stopEditing();
    },
    onBtStartEditing(key, char, pinned) {
      this.gridApi.setFocusedCell(0, "lastName", pinned);
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "lastName",
        // set to 'top', 'bottom' or undefined
        rowPinned: pinned,
        key: key,
        charPress: char
      });
    },
    onBtNextCell() {
      this.gridApi.tabToNextCell();
    },
    onBtPreviousCell() {
      this.gridApi.tabToPreviousCell();
    },
    onRowValueChanged(params) { },
    getTanimList(tanim) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        COMPANYID: state.MusteriId,
        ROOT: tanim == "UNIT" || tanim == "DEPOTID" ? "" : "VE_STOCK",
        ROOTFIELD: tanim
      };
      soap.createClient(url, function (err, client) {
        client.TANIMLIST(args, function (err, result) {
          if (result.TANIMLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.TANIMLISTResult);
          if (tanim == "DEPOTID") vm.ANADEPOOPTION = vm.veriler;
          else if (tanim == "UNIT") vm.ANAUNITOPTION = vm.veriler;
          else if (tanim == "GROUPCODE") vm.GROUPCODEOPTION = vm.veriler;
          else if (tanim == "SPECCODE1") vm.SPECCODE1OPTION = vm.veriler;
          else if (tanim == "SPECCODE2") vm.SPECCODE2OPTION = vm.veriler;
        });
      });
    },
    lotKontrol2(index, upt) {
      var vs = this.$vs;
      if (this.isfollowLots == true && this.items.length > 0) {
        let kontrolForLot = [];

        this.rowdata.forEach((val, index) => {

          if (val.FOLLOWLOT == true) {
            let miktarUyumKontrol = this.items.filter(post => {
              return post.STOCKID == val.MIXSTOCKID;
            });

            let toplamLotMikk = 0.0;
            miktarUyumKontrol.forEach((val, index) => {
              toplamLotMikk += parseFloat(val.lotMiktar);
            });
            console.log(toplamLotMikk.toFixed(5))
            /*  if (parseFloat(val.MIXQUANTITY).toFixed(5) == toplamLotMikk.toFixed(5)) {
                kontrolForLot.push(true);
              } else {
                kontrolForLot.push(false);
              }*/
          }
        });

      }
    },

    lotKontrol(index, upt) {
      var vs = this.$vs;
      if (this.isfollowLots == false) {
        this.uretimKaydet(index, upt);
      } else if (this.isfollowLots == true && this.items.length > 0) {
        let kontrolForLot = [];

        this.rowdata.forEach((val, index) => {

          if (val.FOLLOWLOT == true) {
            let miktarUyumKontrol = this.items.filter(post => {
              return post.STOCKID == val.MIXSTOCKID;
            });

            let toplamLotMikk = 0.0;
            miktarUyumKontrol.forEach((val, index) => {
              toplamLotMikk += parseFloat(val.lotMiktar);
            });

            if (parseFloat(val.MIXQUANTITY).toFixed(5) == toplamLotMikk.toFixed(5)) {
              kontrolForLot.push(true);
            } else {
              kontrolForLot.push(false);
            }
          }
        });
        if (kontrolForLot.toString().includes("false") == true) {
          vs.notify({
            title: "Lot İşlemi",
            text: "Eksik ya da fazla lot girişi yaptınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        } else {
          this.uretimKaydet(index, upt);
        }
      } else {
        vs.notify({
          title: "Lot İşlemi",
          text: "Lot girişi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      }
    },

    uretimKaydet(index, upt) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const stokY = new Date().getFullYear();
      let fisVal = vm.maxVal;

      try {
        if (vm.rowdata !== null) {
          if (typeof vm.rowdata[index] != "undefined") {
            let args = {};
            if (upt == "UPDATE") {
              args = {
                token: Store.state.tokenId,
                ISLEM: "GUNCELLE",
                UNITID: vm.rowdata[index].MIXSTOCKUNIT, //edit
                DEPOTID: vm.rowdata[index].MIXDEPOTID, //edit
                QUANTITY: vm.rowdata[index].QUANTITY.toString().replace(",", "."),
                DESCRIPTION: vm.rowdata[index].DESCRIPTION,
                ISMIX: vm.rowdata[index].ISMIX == true ? true : false,
                ITEMNO: vm.rowdata[index].ITEMNO, //artan
                TOTAL:
                  isNaN(
                    vm.rowdata[index].MIXPRICE * vm.rowdata[index].MIXQUANTITY
                  ) == true
                    ? 0
                    : vm.rowdata[index].MIXPRICE *
                    vm.rowdata[index].MIXQUANTITY,
                EMPLOYEEID: state.MusteriId,
                CURRCODE: vm.rowdata[index].CURRCODE,
                INSERTUSERID: state.UserId,
                EDITUSERID: state.UserId,
                PRICE: vm.rowdata[index].MIXPRICE, //sarf edit+
                GROUPCODE: vm.rowdata[index].MIXGROUPCODE, //edit+
                SPECCODE1: vm.rowdata[index].MIXSPECCODE1, //edit+
                SPECCODE2: vm.rowdata[index].MIXSPECCODE2, //edit+
                RECEIPTID: vm.RECEIPTID,
                ANASTOCKID: vm.STOCKID
              };
              console.log("1")
              console.log(args)

              soap.createClient(url, function (err, client) {
                client.STOCKPRO(args, function (err, result) {
                  if (result.STOCKPROResult == "-1") {
                    Store.dispatch("logout");
                    //this.$store.dispatch('login', payload)
                  }
                  vm.veriler = JSON.parse(result.STOCKPROResult);
                  try {
                    if (vm.veriler.response == "Ok") {
                      index++;
                      vm.uretimKaydet(index, "UPDATE");
                    } else {
                      vs.notify({
                        title: "Reçete Listesi",
                        text: vm.veriler.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-center"
                      });
                    }
                  } catch (error) {
                    vs.notify({
                      title: "Reçete Listesi",
                      text: "Beklenmedik Hata",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-center"
                    });
                  }
                });
              });
            } else if (upt == "DEL") {
              args = {
                token: Store.state.tokenId,
                ISLEM: "DEL",
                RECEIPTID: vm.RECEIPTID //tarih(2023-0001)
              };
              soap.createClient(url, function (err, client) {
                client.STOCKPRO(args, function (err, result) {
                  if (result.STOCKPROResult == "-1") {
                    Store.dispatch("logout");
                    //this.$store.dispatch('login', payload)
                  }
                  vm.veriler = JSON.parse(result.STOCKPROResult);
                  try {
                    if (vm.veriler.response == "Ok") {
                      index++;
                      vm.uretimKaydet(index, "DEL");
                    } else {
                      vs.notify({
                        title: "Reçete Listesi",
                        text: vm.veriler.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-center"
                      });
                    }
                  } catch (error) {
                    vs.notify({
                      title: "Reçete Listesi",
                      text: "Beklenmedik Hata",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-center"
                    });
                  }
                });
              });
            } else {
              vm.uretimTotal +=
                isNaN(
                  vm.rowdata[index].MIXPRICE * vm.rowdata[index].MIXQUANTITY
                ) == true
                  ? 0
                  : vm.rowdata[index].MIXPRICE * vm.rowdata[index].MIXQUANTITY;
              vm.uretimPriceTotal +=
                isNaN(vm.rowdata[index].MIXPRICE) == true
                  ? 0
                  : vm.rowdata[index].MIXPRICE;
              if (typeof vm.rowdata[index].MIXSTOCKID != "undefined") {



                args = {
                  token: Store.state.tokenId,
                  ISLEM: "EKLE",
                  STOCKID: vm.rowdata[index].MIXSTOCKID, //yukardaki
                  UNITID: vm.rowdata[index].MIXSTOCKUNIT, //edit
                  DEPOTID: vm.rowdata[index].MIXDEPOTID, //edit
                  QUANTITY: parseFloat(vm.rowdata[index].MIXQUANTITY).toFixed(5).toString().replace(",", "."), //kalemdeki
                  ANAQUANTITY: vm.miktarDeger.replace(",", "."),
                  ISMIX: vm.rowdata[index].ISMIX == true ? true : false,
                  BARCODE: "",
                  DESCRIPTION: vm.rowdata[index].DESCRIPTION,
                  ITEMNO: index, //artan
                  TOTAL:
                    isNaN(
                      vm.rowdata[index].MIXPRICE * parseFloat(vm.rowdata[index].MIXQUANTITY)
                    ) == true
                      ? 0
                      : vm.rowdata[index].MIXPRICE *
                      parseFloat(vm.rowdata[index].MIXQUANTITY),
                  EMPLOYEEID: state.MusteriId,
                  CURRCODE: vm.rowdata[index].CURRCODE,
                  INSERTUSERID: state.UserId,
                  EDITUSERID: state.UserId,
                  PRICE: vm.rowdata[index].MIXPRICE, //sarf edit
                  GROUPCODE: vm.rowdata[index].MIXGROUPCODE, //edit
                  SPECCODE1: vm.rowdata[index].MIXSPECCODE1, //edit
                  SPECCODE2: vm.rowdata[index].MIXSPECCODE2, //edit
                  RECEIPTID: fisVal,
                  ANASTOCKID: vm.STOCKID
                };
                console.log(args)
                soap.createClient(url, function (err, client) {
                  client.STOCKPRO(args, function (err, result) {
                    if (result.STOCKPROResult == "-1") {
                      Store.dispatch("logout");
                      //this.$store.dispatch('login', payload)
                    }
                    vm.veriler = JSON.parse(result.STOCKPROResult);
                    try {
                      if (vm.veriler.response == "Ok") {
                        index++;
                        vm.uretimKaydet(index);
                      } else {
                        vs.notify({
                          title: "Üretim İşlemi",
                          text: vm.veriler.message,
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "warning",
                          position: "top-center"
                        });
                      }
                    } catch (error) {
                      console.log(error);
                      vs.notify({
                        title: "Üretim İşlemi",
                        text: "Beklenmedik Hata",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                        position: "top-center"
                      });
                    }
                  });
                });
              }
            }
          } else {
            vs.notify({
              title: "Üretim İşlemi",
              text: "Tüm Üretim Kalem bilgileri kaydedildi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
            this.uretimBaslikKaydet(upt);

            this.STOCK = "";
            this.SPECCODE1CODE = "";
            this.SPECCODE2CODE = "";
            this.SPECCODE1 = "";
            this.SPECCODE2 = "";
            this.GROUPCODE = "";
            this.GROUPCODECODE = "";
            this.RECEIPTNO = "";
            this.DEPOID = "";
            this.PRICE = "";
            this.rowdata = [];
            this.tableheight = "";
            this.CATAGORY1 = "";
            this.DESCRIPTION = "";
          }
        } else {
          this.uretimBaslikKaydet(upt);
        }
      } catch (error) {
        console.log(error)
        vs.notify({
          title: "Üretim İşlemi",
          text: "Daha önce üretim kaydı yapılmış olabilir",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center"
        });
      }
    },
    uretimBaslikKaydet(upt) {
      var vm = this;
      var vs = this.$vs;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      let fisVal = vm.maxVal;
      if (upt == "UPDATE") {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "GUNCELLE",
          STOCKID: vm.STOCKID, //yukardaki
          DEPOTID: vm.DEPOID.CODE, //edit
          QUANTITY: vm.miktarDeger, //kalemdek
          STATUS: vm.STATUS.val,
          DESCRIPTION: vm.DESCRIPTION,
          TOTAL:
            isNaN(parseFloat(vm.uretimTotal)) == true
              ? 0
              : parseFloat(vm.uretimTotal),
          EMPLOYEEID: state.MusteriId,
          EDITUSERID: state.UserId,
          PRICE:
            isNaN(parseFloat(vm.uretimTotal) / parseFloat(vm.miktarDeger)) ==
              true
              ? 0
              : parseFloat(vm.uretimTotal) / parseFloat(vm.miktarDeger), //sarf edit
          GROUPCODE: vm.GROUPCODE.CODE, //edit
          SPECCODE1: vm.SPECCODE1.CODE, //edit
          SPECCODE2: vm.SPECCODE2.CODE, //edit
          RECEIPTID: vm.RECEIPTID,
          STOCKLOTSID: vm.lotDeger
        };

        soap.createClient(url, function (err, client) {
          client.STOCKPROBASLIK(args, function (err, result) {
            if (result.STOCKPROBASLIKResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKPROBASLIKResult);
            try {
              if (vm.veriler.response == "Ok") {
                vm.getUretimList();
                vm.addStokTransfer();
                // vm.$refs["modal-yeniPro"].hide();
                vm.popupActive2 = false;
                vs.notify({
                  title: "Üretim İşlemi",
                  text: "Üretim Başlık bilgisi kaydedildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } else {
                vs.notify({
                  title: "Üretim İşlemi",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Üretim İşlemi",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      } else if (upt == "DEL") {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "DEL",
          RECEIPTID: vm.RECEIPTID //tarih(2023-0001)
        };
        soap.createClient(url, function (err, client) {
          client.STOCKPROBASLIK(args, function (err, result) {
            if (result.STOCKPROBASLIKResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKPROBASLIKResult);
            try {
              if (vm.veriler.response == "Ok") {
                vm.lotsKayit(0, "DEL", vm.RECEIPTID);

                vm.getUretimList();
                vm.popupActive2 = false;

                vs.notify({
                  title: "Üretim İşlemi",
                  text: "Üretim Silme İşlemi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } else {
                vs.notify({
                  title: "Üretim İşlemi",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Üretim İşlemi",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "EKLE",
          STOCKID: vm.STOCKID, //yukardaki
          DEPOTID: vm.DEPOID.CODE, //edit
          QUANTITY: vm.miktarDeger, //kalemdek
          STOCKLOTSID: vm.lotDeger,
          STATUS: vm.STATUS.val,
          DESCRIPTION: vm.DESCRIPTION,
          TOTAL:
            isNaN(parseFloat(vm.uretimTotal)) == true
              ? 0
              : parseFloat(vm.uretimTotal),
          EMPLOYEEID: state.MusteriId,
          EDITUSERID: state.UserId,
          PRICE:
            isNaN(parseFloat(vm.uretimTotal) / parseFloat(vm.miktarDeger)) ==
              true
              ? 0
              : parseFloat(vm.uretimTotal) / parseFloat(vm.miktarDeger), //sarf edit
          GROUPCODE: vm.GROUPCODE.CODE, //edit
          SPECCODE1: vm.SPECCODE1.CODE, //edit
          SPECCODE2: vm.SPECCODE2.CODE, //edit
          RECEIPTID: fisVal
        };

        soap.createClient(url, function (err, client) {
          client.STOCKPROBASLIK(args, function (err, result) {
            if (result.STOCKPROBASLIKResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.STOCKPROBASLIKResult);
            vm.uretimTotal = 0.0;
            vm.uretimPriceTotal = 0.0;
            try {
              if (vm.veriler.response == "Ok") {
                if (vm.isfollowLots == true) {
                  vm.lotsKayit(0, "EKLE");
                } else {
                  vm.getUretimList();
                  vm.popupActive2 = false;
                }
                vs.notify({
                  title: "Üretim İşlemi",
                  text: "Üretim Başlık bilgisi kaydedildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } else {
                vs.notify({
                  title: "Üretim İşlemi",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.notify({
                title: "Üretim İşlemi",
                text: "Beklenmedik Hata",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    lotsKayit(index, islem, fisId, upislem) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      let fisVal = vm.maxVal;
      if (typeof vm.items[index] == "undefined") {
        if (upislem == "UPTONAY") {
          vm.getLotsListForVal(vm.RECEIPTID);
          vs.notify({
            title: "Üretim İşlem",
            text: "Lot kaydı yapıldı",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center"
          });
        } else {
          if (islem == "UPT") {
            setTimeout(() => {
              vm.addLotsCard();
            }, 1000);
            vm.stokLotsTransAdd(0);
          } else vm.getUretimList();
          vm.popupActive2 = false;
          vm.items = [
            {
              id: 0,
              lotKodu: "",
              lotMiktar: "",
              kod: "",
              disabled: false,
              ROOT: "",
              ROOTFIELD: "",
              STOCKLOTSID: "",
              COMPANYID: "",
              STOCKID: ""
            }
          ];
        }
      } else {
        if (
          vm.items[index].uptKontrol == true &&
          vm.items[index].disabled == true
        ) {
          const args = {
            token: Store.state.tokenId,
            COMPANYID: state.MusteriId,
            ROOT: "306",
            STOCKLOTSID: vm.items[index].STOCKLOTSID,
            QUANTITY: vm.items[index].lotMiktar,
            DEPOTID: vm.items[index].DEPOTID,
            ISLEM: "EKLE",
            STOCKLOTSNO: vm.items[index].lotKodu,
            ROOTRECEIPTITEMNO: vm.items[index].ITEMNO + 1,
            ROOTID:
              islem == "DEL" || islem == "UPT" || upislem == "UPTONAY"
                ? fisId
                : fisVal,
            STATUS: islem == "UPT" ? 2 : 1,
            STOCKID: vm.items[index].STOCKID,
            PRICE: vm.items[index].LOTPRICE,
            CURRPRICE: vm.items[index].CURRPRICE,
            CURRTOTAL: vm.items[index].CURRPRICE * vm.items[index].lotMiktar,
            CURRCODE: vm.items[index].CURRCODE
          };

          soap.createClient(url, function (err, client) {
            client.STOCKLOTSADD(args, function (err, result) {
              if (result.STOCKLOTSADDResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              vm.lotsKayit(index + 1, islem, fisId, upislem);

              vm.veriler = JSON.parse(result.STOCKLOTSADDResult);
            });
          });
        } else {
          if (vm.items[index].disabled == true) {
            const args = {
              token: Store.state.tokenId,
              COMPANYID: state.MusteriId,
              ROOT: "306",
              STOCKLOTSID: vm.items[index].STOCKLOTSID,
              QUANTITY: vm.items[index].lotMiktar,
              DEPOTID: vm.items[index].DEPOTID,
              ISLEM: upislem == "UPTONAY" ? "UPT" : islem,
              STOCKLOTSNO: vm.items[index].lotKodu,
              ROOTRECEIPTITEMNO: vm.items[index].ITEMNO + 1,
              ROOTID:
                islem == "DEL" || islem == "UPT" || upislem == "UPTONAY"
                  ? fisId
                  : fisVal,
              STATUS: islem == "UPT" ? 2 : 1,
              STOCKID: vm.items[index].STOCKID,
              PRICE: vm.items[index].LOTPRICE
            };
            soap.createClient(url, function (err, client) {
              client.STOCKLOTSADD(args, function (err, result) {
                if (result.STOCKLOTSADDResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                vm.lotsKayit(index + 1, islem, fisId, upislem);

                vm.veriler = JSON.parse(result.STOCKLOTSADDResult);
              });
            });
          } else {
            if (islem == "UPT") {
              vm.stokLotsTransAdd(0);
            }

            vm.getUretimList();
            vm.popupActive2 = false;
            vm.items = [
              {
                id: 0,
                lotKodu: "",
                lotMiktar: "",
                kod: "",
                disabled: false,
                ROOT: "",
                ROOTFIELD: "",
                STOCKLOTSID: "",
                COMPANYID: "",
                STOCKID: ""
              }
            ];
          }
        }
      }
    },
    addStokTransfer() { },
    getUretimList(kontrol) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      if (kontrol == "") {
        vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: "#loading-material",
          scale: 0.45
        });
      }

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        ARANAN: "",
        COMPANYID: state.MusteriId,
        token: Store.state.tokenId
      };

      soap.createClient(url, function (err, client) {
        client.STOCKPROLIST(args, function (err, result) {
          if (result.STOCKPROLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKPROLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              setTimeout(() => {
                vm.$vs.loading.close("#loading-material > .con-vs-loading");
              }, 1000);

              vm.rowdataUretim = JSON.parse(vm.veriler.jsonData);
              let columnList = [];
              vm.rowdataUretim.forEach((val, index) => {
                columnList.push(val.RECEIPTID);
                val.detay = JSON.parse(val.detay);
              });
              vm.detailCellRendererParams = {
                detailGridOptions: {
                  rowSelection: "multiple",
                  suppressRowClickSelection: true,
                  enableRangeSelection: true,
                  columnDefs: [
                    { field: "MIXSTOCKNO", headerName: "Stok No" },
                    { field: "MIXSTOCKNAME", headerName: "Stok Adı" },
                    { field: "MIXSTOCKUNITDESC", headerName: "Birim" },
                    { field: "MIXDEPOTIDDESC", headerName: "Depo" },
                    { field: "MIXQUANTITY", headerName: "Adet" },
                    {
                      field: "MIXPRICE",
                      headerName: "Fiyat",
                      hide: vm.yetkiTipi == "Admin" ? false : true
                    },
                    { field: "MIXGROUPCODEDESC", headerName: "Grup Kodu" },
                    { field: "MIXSPECCODE1DESC", headerName: "Özel Kod 1" },
                    { field: "MIXSPECCODE2DESC", headerName: "Özel Kod 2" },
                    { field: "DESCRIPTION", headerName: "Açıklama" }
                  ],
                  defaultColDef: {
                    sortable: true,
                    flex: 1
                  }
                },
                getDetailRowData: params => {
                  params.successCallback(params.data.detay);
                }
              };
              //  if (columnList.length == 0) vm.maxVal = 0;
              //     else vm.maxVal = Math.max.apply(Math, columnList);
              vm.getMaxVal();
            } else {
              setTimeout(() => {
                vm.$vs.loading.close("#loading-material > .con-vs-loading");
              }, 1000);
              vs.notify({
                title: "Üretim Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            setTimeout(() => {
              vm.$vs.loading.close("#loading-material > .con-vs-loading");
            }, 1000);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    getMaxVal() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        baslik: "WORKPRO",
        param: "RECEIPTID"
      };
      soap.createClient(url, function (err, client) {
        client.getMaxVal(args, function (err, result) {
          if (result.getMaxValResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.getMaxValResult);
          let listForMAxVal = JSON.parse(vm.veriler.jsonData);
          vm.maxVal = listForMAxVal[0].SONNO;
          if (
            typeof listForMAxVal[0].SONNO == "undefined" ||
            listForMAxVal[0].SONNO == ""
          )
            vm.maxVal = 1;
        });
      });
    },
    setSpeccode2KodData(sonuc, ind) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(ind);
      rowNode.setDataValue("MIXSPECCODE2DESC", sonuc.DESCRIPTION);
      rowNode.setDataValue("MIXSPECCODE2", sonuc.CODE);
    },
    setSpeccode1KodData(sonuc, ind) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(ind);
      rowNode.setDataValue("MIXSPECCODE1DESC", sonuc.DESCRIPTION);
      rowNode.setDataValue("MIXSPECCODE1", sonuc.CODE);
    },
    setGrupKodData(sonuc, ind) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(ind);
      rowNode.setDataValue("MIXGROUPCODEDESC", sonuc.DESCRIPTION);
      rowNode.setDataValue("MIXGROUPCODE", sonuc.CODE);
    },
    setDepoData(sonuc, ind) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(ind);
      rowNode.setDataValue("MIXDEPOTIDDESC", sonuc.DESCRIPTION);
      rowNode.setDataValue("MIXDEPOTID", sonuc.CODE);
    },
    setBirimData(sonuc, ind) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(ind);
      rowNode.setDataValue("MIXSTOCKUNITDESC", sonuc.UNITNAME);
      rowNode.setDataValue("MIXSTOCKUNIT", sonuc.UNITID);
    },
    setSonucData(sonuc) {
      this.setMiktarVal(0);
    },
    setMiktarVal(index) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

      if (typeof this.rowdata[index] == "undefined") {
      } else {
        if (rowNode.data.STOCKIDLOSS == true) {
          // this.popupActive3 = true;
          //   this.getLots(val.STOCKID);
          //    this.$refs["modal-yeniPro"].show();
          //     this.globIndex = index;
        } else {

          rowNode.setDataValue(
            "MIXQUANTITY",
            parseFloat(this.rowdata[index].MIXQUANTITY2) *
            parseFloat(this.miktarDeger)
          );
          this.setMiktarVal(index + 1);
        }
      }
    },
    getLots(STOCKID, DEPOTID) {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: STOCKID,
        DEPOTID: DEPOTID
      };
      console.log(args)
      soap.createClient(url, function (err, client) {
        client.STOCKLOTSLIST(args, function (err, result) {
          if (result.STOCKLOTSLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);

              vm.$refs["modal-lotList"].show();
              vm.rowdataLotList = lotsList;
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    yeniKayit(upt) {
      if (upt != "UPDATE") this.UretimDurumu = "";
      this.onayButonKontrol = false;
      this.isfollowLots = false;
      this.STOCK = "";
      this.SPECCODE1CODE = "";
      this.SPECCODE2CODE = "";
      this.SPECCODE1 = "";
      this.SPECCODE2 = "";
      this.GROUPCODE = "";
      this.GROUPCODECODE = "";
      this.RECEIPTNO = "";
      this.RECEIPTID = "";
      this.DEPOID = "";
      this.PRICE = "";
      this.rowdata = [];
      this.tableheight = "";
      this.CATAGORY1 = "";
      this.DESCRIPTION = "";
      this.updateValidate = false;
      this.stokArananInput = "";
      //  this.$refs["modal-yeniPro"].show();
      this.popupActive2 = true;
      this.items = [
        {
          id: 0,
          lotKodu: "",
          lotMiktar: "",
          kod: "",
          disabled: false,
          ROOT: "",
          ROOTFIELD: "",
          STOCKLOTSID: "",
          COMPANYID: "",
          STOCKID: ""
        }
      ];
    },
    uretimDetay() {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        RECEIPTID: vm.RECEIPTID
      };

      soap.createClient(url, function (err, client) {
        client.STOCKPROITEMLIST(args, function (err, result) {
          if (result.STOCKPROITEMLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKPROITEMLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let receteList = JSON.parse(vm.veriler.jsonData);
              vm.rowdata = JSON.parse(vm.veriler.jsonData);
              vm.rowdata.forEach((val, index) => {
                if (val.FOLLOWLOT == true) {
                  vm.isfollowLots = true;
                }
              });

              //  if (vm.rowdata.length < 2) vm.rowdata.length = 3;
              //   vm.tableheight = vm.rowdata.length * 150;

              vm.$refs["barkodK"][0].focus();
              //  vm.$nextTick(() => vm.$refs["barkodK"][0].focus());
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    getReceteList() {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        ARANAN: vm.stokArananInput
      };

      soap.createClient(url, function (err, client) {
        client.STOCKMIXLIST(args, function (err, result) {
          if (result.STOCKMIXLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKMIXLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let receteList = JSON.parse(vm.veriler.jsonData);
              vm.rowdata = JSON.parse(vm.veriler.jsonData);
              vm.rowdata.forEach((val, index) => {
                vm.rowdata[index] = {
                  COMPANYID: val.COMPANYID,
                  CURRCODE: val.CURRCODE,
                  DEPOTID: val.DEPOTID,
                  DEPOTIDDESC: val.DEPOTIDDESC,
                  FOLLOWLOT: val.FOLLOWLOT,
                  ITEMNO: val.ITEMNO,
                  MIXDEPOTID: val.MIXDEPOTID,
                  MIXDEPOTIDDESC: val.MIXDEPOTIDDESC,
                  MIXPRICE: val.MIXPRICE,
                  MIXQUANTITY: val.MIXQUANTITY,
                  MIXQUANTITY2: val.MIXQUANTITY2,
                  MIXSTOCKID: val.MIXSTOCKID,
                  MIXSTOCKNAME: val.MIXSTOCKNAME,
                  MIXSTOCKNO: val.MIXSTOCKNO,
                  MIXSTOCKUNIT: val.MIXSTOCKUNIT,
                  MIXSTOCKUNITDESC: val.MIXSTOCKUNITDESC,
                  QUANTITY: val.QUANTITY,
                  STOCKID: val.STOCKID,
                  STOCKNAME: val.STOCKNAME,
                  STOCKNO: val.STOCKNO,
                  ISMIX: true
                }
                if (val.FOLLOWLOT == true) {
                  vm.isfollowLots = true;
                }
              });

              //  if (vm.rowdata.length < 2) vm.rowdata.length = 3;
              //   vm.tableheight = vm.rowdata.length * 150;

              vm.$refs["barkodK"][0].focus();
              //  vm.$nextTick(() => vm.$refs["barkodK"][0].focus());
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    getLotsListForVal(fisId) {
      var vm = this;
      var vs = this.$vs;
      vm.items = [];
      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        ROOTID: fisId,
        ISLEM: vm.STOCKID
      };

      soap.createClient(url, function (err, client) {
        client.STOCKLOTSFORRECEIPT(args, function (err, result) {
          if (result.STOCKLOTSFORRECEIPTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLOTSFORRECEIPTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let list = JSON.parse(vm.veriler.jsonData);
              let ind = 1;

              list.forEach((val, index) => {
                vm.items.push({
                  id: ind + index,
                  lotKodu: val.STOCKLOTSNO,
                  lotMiktar: val.QUANTITY.toFixed(5),
                  kod: val.ROOT,
                  disabled: true,
                  ROOT: val.ROOT,
                  ROOTFIELD: val.ROOTID,
                  STOCKLOTSID: val.STOCKLOTSID,
                  COMPANYID: val.ROOT,
                  STOCKID: val.STOCKID,
                  STOCKNO: val.STOCKNO,
                  STOCKNAME: val.STOCKNAME,
                  DEPOTID: val.DEPOTID,
                  LOTPRICE: val.LOTPRICE,
                  CURRPRICE: val.CURRPRICE,
                  CURRTOTAL: val.CURRTOTAL,
                  CURRCODE: val.CURRCODE,
                  UNITID: val.UNITID,
                  ITEMNO: val.ROOTRECEIPTITEMNO,
                  onayKontrol: val.STATUS == 1 || val.STATUS == 2 ? false : true
                });
              });

              let miktarUyumKontrol = vm.items.filter(post => {
                return post.onayKontrol.toString() == "true";
              });
              if (miktarUyumKontrol.length == 0) {
                vm.lotDurumKontrol = true; //içinde true değeri yoksa
              } else vm.lotDurumKontrol = false;

              vm.$refs["barkodM"].focus();
            } else {
              vs.notify({
                title: "Lot listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(error);
            /*  vs.notify({
              title: "Lot listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });*/
          }
        });
      });
    },
    getSuggestionValue2(suggestion, upd) {
      console.log(suggestion.item)
      this.secilenStok = [];
      this.secilenStokInfo = suggestion.item;
      this.RECEIPTID = suggestion.item.RECEIPTID;
      this.COMPANYID = suggestion.item.COMPANYID;
      this.miktarDeger = suggestion.item.QUANTITY;
      this.lotDeger = suggestion.item.STOCKLOTSID;
      this.genelDurum = suggestion.item.durum;

      this.STOCKID = suggestion.item.STOCKID;
      this.$store.commit("uzum/MPSTOCKSTOCKID", this.STOCKID);
      this.STOCKNO = suggestion.item.STOCKNO;
      this.STOCKNAME = suggestion.item.STOCKNAME;
      this.STOCKNAME2 = suggestion.item.STOCKNAME2;
      this.STATUS = {
        name: suggestion.item.STATUS == 2 ? "Aktif" : "Pasif",
        val: suggestion.item.STATUS
      };
      this.DEPOID = {
        CODE: suggestion.item.DEPOIDCODE,
        DESCRIPTION: suggestion.item.DEPOTID
      };
      this.UNIT = suggestion.item.UNITID;
      this.VAT = suggestion.item.VAT;
      this.GROUPCODE = {
        CODE: suggestion.item.GROUPCODE,
        DESCRIPTION: suggestion.item.GROUPCODEDESC
      };
      this.SPECCODE1 = {
        CODE: suggestion.item.SPECCODE1,
        DESCRIPTION: suggestion.item.SPECCODE1DESC
      };
      this.SPECCODE2 = {
        CODE: suggestion.item.SPECCODE2,
        DESCRIPTION: suggestion.item.SPECCODE2DESC
      };
      this.SPECCODE3 = suggestion.item.SPECCODE3;
      this.SPECCODE4 = suggestion.item.SPECCODE4;
      this.SPECCODE5 = suggestion.item.SPECCODE5;
      this.SEASON = suggestion.item.SEASON;
      this.BRAND = suggestion.item.BRAND;
      this.MODEL = suggestion.item.MODEL;
      this.CATAGORY1 = suggestion.item.CATAGORY1;
      this.CATAGORY2 = suggestion.item.CATAGORY2;
      this.CATAGORY3 = suggestion.item.CATAGORY3;
      this.CATAGORY4 = suggestion.item.CATAGORY4;
      this.CATAGORY5 = suggestion.item.CATAGORY5;
      this.CURRCODE = suggestion.item.CURRCODE;
      this.PRICE = suggestion.item.PRICE;
      this.PRICE2 = suggestion.item.PRICE2;
      this.PRICE3 = suggestion.item.PRICE3;
      this.PRICE4 = suggestion.item.PRICE4;
      this.PRICE5 = suggestion.item.PRICE5;
      this.BARCODE = suggestion.item.BARCODE;
      this.BARCODE1 = suggestion.item.BARCODE1;
      this.BARCODE2 = suggestion.item.BARCODE2;
      this.BARCODE3 = suggestion.item.BARCODE3;
      this.BARCODE4 = suggestion.item.BARCODE4;
      this.CUSTOMERSTOCKNO = suggestion.item.CUSTOMERSTOCKNO;
      this.SUPPLIERSTOCKNO = suggestion.item.SUPPLIERSTOCKNO;
      this.WEBSTOCK = suggestion.item.WEBSTOCK;
      this.ORIGIN = suggestion.item.ORIGIN;
      this.BARKOD = suggestion.item.BARKOD;
      this.DESCRIPTION = suggestion.item.DESCRIPTION;
      this.NOTES = suggestion.item.NOTES;
      this.INSERTDATE = suggestion.item.INSERTDATE;
      this.INSERTUSER = suggestion.item.INSERTUSER;
      this.EDITDATE = suggestion.item.EDITDATE;
      this.EDITUSER = suggestion.item.EDITUSER;

      this.UNITCODE = suggestion.item.UNITCODE;
      this.GROUPCODECODE = suggestion.item.GROUPCODECODE;
      this.SPECCODE1CODE = suggestion.item.SPECCODE1CODE;
      this.SPECCODE2CODE = suggestion.item.SPECCODE2CODE;
      this.SPECCODE3CODE = suggestion.item.SPECCODE3CODE;
      this.SPECCODE4CODE = suggestion.item.SPECCODE4CODE;
      this.SPECCODE5CODE = suggestion.item.SPECCODE5CODE;
      this.CURRCODECODE = suggestion.item.CURRCODECODE;
      this.CATAGORY1CODE = suggestion.item.CATAGORY1CODE;
      this.CATAGORY2CODE = suggestion.item.CATAGORY2CODE;
      this.CATAGORY3CODE = suggestion.item.CATAGORY3CODE;
      this.CATAGORY4CODE = suggestion.item.CATAGORY4CODE;
      this.CATAGORY5CODE = suggestion.item.CATAGORY5CODE;
      if (upd == "UPDATE") {
        this.yeniKayit(upd);
        this.getLotsListForVal(suggestion.item.RECEIPTID);
        this.updateValidate = true;
        this.STOCK = suggestion.item.STOCKNAME;
        this.lotDeger = suggestion.item.RECEIPTNO;
        this.SPECCODE1CODE = suggestion.item.SPECCODE1;
        this.SPECCODE2CODE = suggestion.item.SPECCODE2;
        this.GROUPCODE = {
          CODE: suggestion.item.GROUPCODE,
          DESCRIPTION: suggestion.item.GROUPCODEDESC
        };
        this.SPECCODE1 = {
          CODE: suggestion.item.SPECCODE1,
          DESCRIPTION: suggestion.item.SPECCODE1DESC
        };
        this.SPECCODE2 = {
          CODE: suggestion.item.SPECCODE2,
          DESCRIPTION: suggestion.item.SPECCODE2DESC
        };
        this.GROUPCODECODE = suggestion.item.GROUPCODE;
        this.RECEIPTNO = suggestion.item.RECEIPTNO;
        this.RECEIPTID = suggestion.item.RECEIPTID;

        this.DEPOID = {
          CODE: suggestion.item.DEPOTID,
          DESCRIPTION: suggestion.item.DEPOTIDDESC
        };
        this.DESCRIPTION = suggestion.item.DESCRIPTION;

        this.PRICE = suggestion.item.PRICE;
        //  this.rowdata = suggestion.item.detay;
        this.stokArananInput = this.STOCKNO;
        this.uretimDetay();
        this.tableheight = this.rowdata.length * 150;
      } else {
        this.stokArananInput = suggestion.item.STOCKNO;
        this.getReceteList();
        this.getUretimList();
      }
      return (
        suggestion.item.STOCKNO.trim() + "/" + suggestion.item.STOCKNAME.trim()
      );
    },
    changedVal(val) {
      //this.stokArananInput = val;
    },
    stokLotBilgisi() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.STOCK,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function (err, client) {
        client.STOCK(args, function (err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKResult);
          vm.stokListesi = JSON.parse(vm.veriler.jsonData);
          vm.filteredOptions2 = [
            {
              data: vm.stokListesi.filter(option => {
                return (
                  option.STOCKNO.toLowerCase().indexOf(vm.stokArananInput) >
                  -1 ||
                  option.STOCKNAME.toLowerCase().indexOf(vm.stokArananInput) >
                  -1
                );
              })
            }
          ];
        });
      });
    },
    stokSecilen() { },
    getStokList() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.STOCK,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function (err, client) {
        client.STOCK(args, function (err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKResult);
          vm.stokListesi = JSON.parse(vm.veriler.jsonData);
          vm.filteredOptions2 = [
            {
              data: vm.stokListesi.filter(option => {
                return (
                  option.STOCKNO.toLowerCase().indexOf(vm.stokArananInput) >
                  -1 ||
                  option.STOCKNAME.toLowerCase().indexOf(vm.stokArananInput) >
                  -1
                );
              })
            }
          ];
        });
      });
    }
  },
  mounted() {
    this.types.forEach(type => {
      this.$vs.loading({
        container: `#loading-${type}`,
        type,
        text: type,
        scale: 0.55
      });
    });
    //tables global olarak tanımlanıyor
    this.$root.$on("removeRowRecete", item => {
      this.removeRowRecete(item);
    });
    this.$root.$on("setStokValue", (index, item, stokid, group) => {
      this.setStokValue(index, item, stokid, group);
    });
    this.$root.$on("uretimKaydet", (sonuc, upd, rep, data) => {
      this.RECEIPTID = rep;
      this.rowdata = data;
      this.activePrompt = true;
    });
    this.$root.$on("stokLotBilgisi", data => {
      console.log(data)
      this.lotsStokStokName = data.MIXSTOCKNAME;
      this.lotsStokStokNo = data.MIXSTOCKNO;
      this.globstokId = data.MIXSTOCKID;
      if (this.UretimDurumu == "UPDATE") this.globstokId = data.STOCKID;
      this.getLots(this.globstokId, data.MIXDEPOTID);
    });
    this.$root.$on("getSuggestionUretimVal", (sonuc, upd) => {
      this.UretimDurumu = upd;
      this.getSuggestionValue2(sonuc, upd);
    });
    this.$root.$on("setBirimData", (sonuc, ind) => {
      this.setBirimData(sonuc, ind);
    });
    this.$root.$on("setDepoData", (sonuc, ind) => {
      this.setDepoData(sonuc, ind);
    });
    this.$root.$on("setGrupKodData", (sonuc, ind) => {
      this.setGrupKodData(sonuc, ind);
    });
    this.$root.$on("setSpeccode1KodData", (sonuc, ind) => {
      this.setSpeccode1KodData(sonuc, ind);
    });
    this.$root.$on("setSpeccode2KodData", (sonuc, ind) => {
      this.setSpeccode2KodData(sonuc, ind);
    });
  },
  beforeDestroy() {
    this.$root.$off("setStokValue");
    this.$root.$off("getSuggestionUretimVal");
    this.$root.$off("stokLotBilgisi");
    this.$root.$off("setBirimData");
    this.$root.$off("setDepoData");
    this.$root.$off("setGrupKodData");
    this.$root.$off("setSpeccode1KodData");
    this.$root.$off("setSpeccode2KodData");
    this.$root.$off("uretimKaydet");
  },
  beforeMount() {
    this.columnDefsUretim = [
      {
        width: 200,
        field: "",
        cellRendererFramework: "MpUretimIslemiButton"
      },

      {
        headerName: "Stok id",
        field: "STOCKID",
        sortable: true,
        hide: true,
        filter: "agTextColumnFilter",
        cellStyle: { fontSize: "12px" },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Fiş No",
        field: "RECEIPTNO",
        cellRenderer: "agGroupCellRenderer",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        cellStyle: { fontSize: "12px" },
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Adet",
        field: "QUANTITY",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Adet 2",
        field: "carpan",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Depo",
        field: "DEPOTIDDESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Grup Kod",
        field: "GROUPCODEDESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Özel Kod 1",
        field: "SPECCODE1DESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Özel Kod 2",
        field: "SPECCODE2DESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      } /*
      {
        headerName: "Fiş No",
        cellStyle: { fontSize: "12px" },
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },*/,
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Durum",
        cellStyle: { fontSize: "12px" },
        field: "durum",
        sortable: true,
        cellRenderer: "UretimDurumGorunumCellRenderer",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefs = [
      {
        width: 200,
        field: "",
        cellRendererFramework: "MpUretimIslemiLotBilgiButton"
      },
      {
        headerName: "Sıra",
        field: "ITEMNO",
        sortable: true,
        filter: "agTextColumnFilter",
        pinned: "left",
        cellStyle: { fontSize: "12px" },
        width: 50,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        cellRendererFramework: "MpUretimIslemiReceteSil",
        sortable: true,
        filter: "agTextColumnFilter",
        pinned: "left",
        cellStyle: { fontSize: "12px" },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Adı",
        field: "MIXSTOCKNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        pinned: "left",
        cellStyle: { fontSize: "12px" },
        editable: true,

        cellEditorSelector: params => {
          return {
            component: "StockAutosuggest",
            popup: true
          };
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Birim",
        field: "MIXSTOCKUNITDESC",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        cellStyle: { fontSize: "12px" },
        cellEditorSelector: params => {
          return {
            component: "UretimStokBirimCellRenderer",
            popup: true
          };
        },
        valueFormatter: params => {
          return params.value;
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      } /*
      {
        headerName: "Grup Kodu",
        field: "MIXGROUPCODEDESC",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        cellStyle: { fontSize: "12px" },
        cellEditorSelector: params => {
          return {
            component: "UretimStokGrupKodCellRenderer",
            popup: true
          };
        },
        valueFormatter: params => {
          return params.value;
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },*/,
      ,
      {
        headerName: "Adet 1",
        field: "MIXQUANTITY",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        valueFormatter: params => {
          if (params.value == "" || typeof params.value == "undefined") {
            return params.value;
          } else {
            return parseFloat(params.value).toFixed(5);
          }
        },
        cellStyle: { fontSize: "12px" },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Adet d",
        field: "MIXQUANTITYREDUCED",
        sortable: true,
        editable: true,
        hide: true,
        filter: "agTextColumnFilter",
        cellStyle: { fontSize: "12px" },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Fiyat",
        cellStyle: { fontSize: "12px" },
        field: "MIXPRICE",
        sortable: true,
        editable: true,
        hide: this.yetkiTipi == "Admin" ? false : true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },

      {
        headerName: "Stok Birim Kodu",
        cellStyle: { fontSize: "12px" },
        field: "MIXGROUPCODE",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      } /*
      {
        headerName: "Özel Kod 1",
        cellStyle: { fontSize: "12px" },
        field: "MIXSPECCODE1DESC",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        cellEditorSelector: params => {
          return {
            component: "UretimStokOzelKod1CellRenderer",
            popup: true
          };
        },
        valueFormatter: params => {
          return params.value;
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },*/,
      {
        headerName: "Özel Kod 1",
        field: "MIXSPECCODE1",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        cellStyle: { fontSize: "12px" },
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      } /*
      {
        headerName: "Özel Kod 2",
        field: "MIXSPECCODE2DESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        cellEditorSelector: params => {
          return {
            component: "UretimStokOzelKod2CellRenderer",
            popup: true
          };
        },
        valueFormatter: params => {
          return params.value;
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },*/,
      {
        headerName: "Özel Kod 2",
        cellStyle: { fontSize: "12px" },
        field: "MIXSPECCODE2",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok Birim Kodu",
        cellStyle: { fontSize: "12px" },
        field: "MIXSTOCKUNIT",
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },

      {
        headerName: "Depo",
        field: "MIXDEPOTIDDESC",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        filter: "agTextColumnFilter",
        editable: true,
        cellEditorSelector: params => {
          return {
            component: "UretimStokDepoCellRenderer",
            popup: true
          };
        },
        valueFormatter: params => {
          return params.value;
        },
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      } /*
      {
        headerName: "Lot No",
        field: "STOCKLOTSID",
        cellStyle: { fontSize: "12px" },
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },*/,
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Lot İşlemi",
        field: "FOLLOWLOT",
        cellStyle: { fontSize: "12px" },
        cellRenderer: "LotDurumCellRenderer",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Depo Kodu",
        field: "MIXDEPOTID",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Stok id",
        field: "MIXSTOCKID",
        cellStyle: { fontSize: "12px" },
        sortable: true,
        editable: true,
        filter: "agTextColumnFilter",
        hide: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
<style lang="scss">
.scroll-hand {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
      transform: translate(0, 4px);
    }

    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }

    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
  z-index: 11111111111;
}

[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}

[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 1000000111111111111111111;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

[dir] #autosuggest__input {
  padding: 5px;
  font-size: 12px;
}

.con-vs-loading .title-loading {
  display: none !important;
}
</style>
